module.exports = __webpack_public_path__ + "img/ireland.b968c78c.png";